import styled from 'styled-components';

export const ToolTip = styled.span`
    visibility: hidden;
    position: absolute;
    top: 0;
    right: 44px;
    padding: 4px 8px;
    border: 1px solid rgb(128,128,0);
    border-radius: 3px;
    background-color:rgb(224,200,0);
    color: black;
    white-space: nowrap;
    opacity: 1;
    box-shadow: 2px 2px 4px 2px rgba(0,0,0, 0.3);
`;